export class ErrorLog {
    DateTime: Date;
    SyncStatus: string;
    Url: string;
    Message: string;

    constructor(init: Partial<ErrorLog>) {
        Object.assign(this, init);
    }
}
